<script setup>
const { eligibility, event } = defineProps({
  eligibility: Object,
  event: Object,
})
const { t, d } = useI18n()
const { convertDateTimeForDisplay } = useTimeZone()
</script>

<template>
  <DSAlert
    type="danger"
    no-close
    class="w-100%"
  >
    {{ t('Registrations are closed') }}.<br>
    <span
      v-if="event.active_registration_status?.registrations_close_at"
      class="text-xs"
    >
      <i18n-t keypath="Registration closed {closedDate}">
        <template #closedDate>
          <time
            class="ml-2px"
            :datetime="
              event.active_registration_status
                ?.registrations_close_at
            "
          >
            {{
              d(convertDateTimeForDisplay(event.active_registration_status?.registrations_close_at), 'long')
            }}
          </time>
        </template>
      </i18n-t>
    </span>
  </DSAlert>
</template>

<i18n>
{
  "en-us": {
    "Registrations are closed": "Registrations are closed",
    "Registration closed {closedDate}": "Registration closed {closedDate}"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Registrations are closed": "Registrierungen geschlossen",
  "Registration closed {closedDate}": "Registrierung geschlossen {closedDate}"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Registrations are closed": "Les inscriptions sont fermées",
  "Registration closed {closedDate}": "Inscription clôturée le {closedDate}"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Registrations are closed": "Las inscripciones están cerradas",
  "Registration closed {closedDate}": "Registro cerrado {closedDate}"
}
</i18n>
